<div (click)="close($event)" (keyup)="close($event)" tabindex=0 class="fixed top-0 left-0 h-screen w-screen bg-[#000] bg-opacity-40 z-40" [ngClass]="isActive? 'block' : 'hidden' "></div>
<div class="fixed bottom-0 left-0 w-full z-50 bg-white transition-all rounded-t-2xl h-1/2 md:h-1/3 p-5 overflow-y-auto" [ngClass]="isActive? 'translate-y-0':'translate-y-full'" >
  <div class="flex w-full justify-end">
    <mat-icon
      (click)="close($event)"
      class="cursor-pointer"
      aria-hidden="false"
      aria-label="Single Tarif icon">close</mat-icon>
  </div>
  <ng-content>
  </ng-content>
</div>

